import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements OnChanges {
  @Input({ required: true }) icon!: string;
  @Input({ required: true }) colorCss!: string;
  @Input() sizeCss = '--icon-medium';
  @Input() slot = 'start';

  private themeService = inject(ThemeService);

  src = '';
  style: Record<string, string> = {
    color: 'var(--white-grey)',
    'font-size': 'var(--icon-medium)',
    'line-height': 'var(--icon-medium)',
  };

  divStyle: Record<string, string> = {
    width: 'var(--icon-medium)',
    height: 'var(--icon-medium)',
  };

  ngOnChanges(_changes: SimpleChanges): void {
    this.updateSrc();
    this.updateStyle();
    this.updateDivStyle();
  }

  private updateSrc(): void {
    const size = this.sizeCss === '--icon-medium' || this.sizeCss === '--icon-small' ? '16' : '24';
    this.src = this.iconPath(this.icon, size);
  }

  private updateDivStyle(): void {
    this.divStyle = {
      width: `var(${this.sizeCss}`,
      height: `var(${this.sizeCss}`,
    };
  }

  private updateStyle(): void {
    this.style = {
      color: `var(${this.colorCss})`,
      'font-size': `var(${this.sizeCss})`,
      'line-height': `var(${this.sizeCss})`,
    };
  }

  private iconPath(name: string, size: string): string {
    return `assets/icons/${this.themeService.iconFolder()}/${name}/${size}.svg`;
  }
}
